import { isMember } from "../utils"


export default {
	background: "https://assets.swoogo.com/uploads/full/1431302-61716bfc6de7e.jpg",
	extras: (
		<>
			<iframe allowfullscreen frameborder="0" id="sponsor-theatre-screen"
				style={{
					width: "calc(67.4% * 1.33333)",
					height: "calc(76.6% * 1.33333)",
					left: "16.2%",
					top: ".9%",
					position: "absolute",
					cursor: "pointer",
					display: "block",
					zIndex: "5",
					overflow: "hidden",
					transformOrigin: "top left",
					transform: "scale(0.75)",
				}}
				src=""
			/>
		</>
	),
	links: [
		{
			height: "8%",
			href: isMember ? "https://isfcongress.tkeventsregistration.com/digital2021/sponsortheatreagenda" : "https://isfcongress.tkeventsregistration.com/digital2021/sponsortheatrenm",
			label: "Agenda",
			left: "0.9%",
			top: "2.1%",
			width: "14.4%",
		},
		// {
		// 	label: "Zoom Session",
		// 	href: "/",
		// 	width: "67.25%",
		// 	height: "76.4%",
		// 	left: "16.35%",
		// 	top: ".9%",
		// },
		{
			gameRule: "sponsor-theatre-beyondtrust",
			height: "6%",
			label: "BeyondTrust",
			left: ".8%",
			top: "14%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=839293&meetingNumber=89430789144",
		},
		{
			gameRule: "sponsor-theatre-bitsight",
			height: "6%",
			label: "BitSight",
			left: ".8%",
			top: "21.8%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=629354&meetingNumber=85661311935",
		},
		{
			gameRule: "sponsor-theatre-crossword",
			height: "6%",
			label: "Crossword Cybersecurity",
			left: ".8%",
			top: "29.6%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=743616&meetingNumber=87065678547",
		},
		{
			gameRule: "sponsor-theatre-crowdstrike",
			height: "6%",
			label: "CrowdStrike",
			left: ".8%",
			top: "37.6%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=828843&meetingNumber=81827809358",
		},
		{
			gameRule: "sponsor-theatre-cybel",
			height: "6%",
			label: "CybelAngel",
			left: ".8%",
			top: "45.4%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=892158&meetingNumber=82796969807",
		},
		{
			gameRule: "sponsor-theatre-huawei",
			height: "6%",
			label: "Huawei Technologies",
			left: ".8%",
			top: "53%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=175907&meetingNumber=86047686931",
		},
		{
			gameRule: "sponsor-theatre-ibm",
			height: "6%",
			label: "IBM Security",
			left: ".8%",
			top: "60.5%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=915262&meetingNumber=87947183828",
		},
		{
			gameRule: "sponsor-theatre-immuniweb",
			height: "6%",
			label: "Immuniweb",
			left: ".8%",
			top: "68.5%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=349732&meetingNumber=84601822043",
		},
		{
			gameRule: "sponsor-theatre-keysight",
			height: "5.7%",
			label: "Keysight Technologies",
			left: "84.5%",
			top: "2.1%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=707490&meetingNumber=86367481483",
		},
		{
			gameRule: "sponsor-theatre-kpmg",
			height: "6%",
			label: "KPMG",
			left: "84.5%",
			top: "10%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=495243&meetingNumber=81755653742",
		},
		{
			gameRule: "sponsor-theatre-onetrust",
			height: "6%",
			label: "OneTrust",
			left: "84.5%",
			top: "17.9%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=116506&meetingNumber=82383335639",
		},
		{
			gameRule: "sponsor-theatre-scorecard",
			height: "6%",
			label: "SecurityScorecard",
			left: "84.5%",
			top: "25.8%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=314689&meetingNumber=86577191078",
		},
		{
			gameRule: "sponsor-theatre-sentinel",
			height: "6%",
			label: "SentinelOne",
			left: "84.5%",
			top: "33.5%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=020968&meetingNumber=84581014428",
		},
		{
			gameRule: "sponsor-theatre-surecloud",
			height: "6%",
			label: "Surecloud",
			left: "84.5%",
			top: "41.3%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=490478&meetingNumber=84935274755",
		},
		{
			gameRule: "sponsor-theatre-synopsys",
			height: "6%",
			label: "Synopsis",
			left: "84.5%",
			top: "49%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=727177&meetingNumber=83241099828",
		},
		{
			gameRule: "sponsor-theatre-tessian",
			height: "6%",
			label: "Tessian",
			left: "84.5%",
			top: "56.7%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=200423&meetingNumber=82365269269",
		},
		{
			gameRule: "sponsor-theatre-veracode",
			height: "6%",
			label: "Veracode",
			left: "84.5%",
			top: "64.5%",
			width: "14.4%",
			onClick: () => document.getElementById("sponsor-theatre-screen").src = "https://isfcongress.tkeventsregistration.com/digital2021/zoom?meetingPassword=440257&meetingNumber=87991871440",
		},
	],
	name: "sponsor-theatre",
}
